import React from 'react';
import ReactDOM from 'react-dom/client';
import { addLocale, locale } from 'primereact/api';
import App from './App';

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

addLocale('tr', {
  emptyFilterMessage: 'Sonuç bulunamadı',
  emptyMessage: 'Uygun seçenek bulunamadı',
  emptySearchMessage: 'Sonuç bulunamadı',
  emptySelectionMessage: 'Seçili öğe yok',
  noFilter: 'Filtre yok',
  searchMessage: '{0} sonuç mevcut',
  selectionMessage: '{0} öğe seçildi'
});

locale('tr');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

